<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>
    <a [routerLink]="['/tasks/library']">LibraryTasks</a>
  </li>
  <li>
    Update Task
  </li>
</ul>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Update Task</strong>
    </span>

    <button type="button" class="btn btn-sm btn-default pull-right btn-back" (click)="ShowCompanyTasks()">
      <i class="fa fa-chevron-circle-left"></i>&nbsp;Back
    </button>
  </div>
  <div class="card-block">
    <div class="row">
      <div class="col-lg-12">
        <div class="margin-bottom-50">
          <form [formGroup]="updateTaskForm" class="well">
            <div class="modal-content">
              <div class="modal-body" style="position: relative;">
                <!-- Loader overlay for update task -->
                <div class="update-task-loader-overlay" *ngIf="isSavingTask">
                  <div class="update-task-loader-container">
                    <img src="assets/images/DigiCompany_loader.png" class="update-task-spinner" alt="Loading..." />
                  </div>
                </div>
                <div class="form-block-row">
                  <div class="row">
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label">Global / Company</label>
                      <div class="form-group form-block-input">
                        <div class="md-radio md-radio-inline">
                          <input id="IsGlobalYes" type="radio" [formControl]="updateTaskForm.controls['IsGlobal']"
                            style="position:absolute" name="IsGlobal" value="Global" class="form-check-input" disabled>
                          <label for="IsGlobalYes">Global</label>
                        </div>
                        <div class="md-radio md-radio-inline">
                          <input id="IsGlobalNo" type="radio" [formControl]="updateTaskForm.controls['IsGlobal']"
                            style="position:absolute" name="IsGlobal" value="Company" class="form-check-input" disabled>
                          <label for="IsGlobalNo">Company</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Trigger Type
                        <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                      </label>
                      <div class="form-group form-block-input">
                        <div class="md-radio md-radio-inline">
                          <input id="IsPeriodic" type="radio" [formControl]="updateTaskForm.controls['TriggerType']"
                            (click)="CheckTriggerType('Periodic')" style="position:absolute" name="TriggerType"
                            value="Periodic" class="form-check-input">
                          <label for="IsPeriodic">Periodic</label>
                        </div>
                        <div class="md-radio md-radio-inline">
                          <input id="IsEvent" type="radio" [formControl]="updateTaskForm.controls['TriggerType']"
                            (click)="CheckTriggerType('Event')" style="position:absolute" name="TriggerType" value="Event"
                            class="form-check-input">
                          <label for="IsEvent">Event</label>
                        </div>
                        <!-- <div
                          *ngIf="updateTaskForm.controls['TriggerType'].hasError('required') && (updateTaskForm.controls['TriggerType'].dirty || updateTaskForm.controls['TriggerType'].pristine)"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please Select Either Periodic Or Event.
                        </div> -->
                      </div>
                    </div>

                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Trigger Id
                        <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                      </label>
                      <ng-container *ngIf="IsTriggerTypeSelected('Event') || IsTriggerTypeSelected('Periodic'); else triggerIdDisabled">
                        <div class="form-group form-block-input" style="position: relative;">
                          <select [formControl]="updateTaskForm.controls['tasktriggerId']"
                            (change)="setTriggerStartDate()" class="form-control select">
                            <option value="">Select</option>
                            <option *ngFor="let taskTriggerType of taskTriggerTypes" value={{taskTriggerType._id}}>
                              {{taskTriggerType.Name}}
                            </option>
                          </select>
                          <!-- <div
                            *ngIf="updateTaskForm.controls['tasktriggerId'].hasError('required') && (updateTaskForm.controls['tasktriggerId'].dirty || updateTaskForm.controls['tasktriggerId'].pristine)"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            Task Trigger type is required.
                          </div> -->
                        </div>
                      </ng-container>
                      <ng-template #triggerIdDisabled>
                        <div class="form-group form-block-input">
                          <select class="form-control select" disabled>
                            <option value="">Select Trigger Type First</option>
                          </select>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                  <div class="row" *ngIf="checkTriggerId(updateTaskForm.controls['tasktriggerId'].value)">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Specific Date</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <app-datepicker-material [formControl]="updateTaskForm.controls['fixedDate']"
                          [(ngModel)]="fixedDateDateModel" [placeholder]="'dd-mm-yyyy'" [minDate]="todaysDate"
                          [disabled]="false" (click)="$event.stopPropagation()" style="width: 100%;">
                        </app-datepicker-material>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="IsTriggerTypeSelected('Periodic')">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Trigger Starting Date
                        <span _ngcontent-c2="" style="color: red;">*</span>
                      </label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <app-datepicker-material [formControl]="updateTaskForm.controls['TriggerStartingDate']"
                          [(ngModel)]="TriggerStartingDateModel" [placeholder]="'dd-mm-yyyy'"
                          [minDate]="triggerStartMinDate" [disabled]="false"
                          (ngModelChange)="dateOfStartDateChangeEvent(); dateOfEndDateChangeEvent()"
                          (click)="$event.stopPropagation()" style="width: 100%;">
                        </app-datepicker-material>
                        <div *ngIf="showTriggerStartDateMessage === true" class="form-control-error-custom" style="position: absolute; top: 100%; left: 50%; transform: translateX(-50%); white-space: nowrap;">
                          Trigger Start Date should not be less than today date.
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">End Date</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <app-datepicker-material [formControl]="updateTaskForm.controls['endDate']"
                          [(ngModel)]="EndDateModel" [placeholder]="'dd-mm-yyyy'"
                          [minDate]="TriggerStartingDateModel" [disabled]="false"
                          (ngModelChange)="dateOfEndDateChangeEvent()"
                          (click)="$event.stopPropagation()" style="width: 100%;">
                        </app-datepicker-material>
                        <div *ngIf="IsTriggerDateGreaterEndDate" class="form-control-error-custom" style="position: absolute; top: 100%; left: 50%; transform: translateX(-50%); white-space: nowrap;">
                          End date should not be prior to Trigger Starting date
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-block-row">
                  <div class="row">
                    <div class="col-md-3 form-block-cell">
                      <label class="form-control-label form-block-label">Statutory / Internal</label>
                      <div class="form-group form-block-input">
                        <select class="form-control" [formControl]="updateTaskForm.controls['PolicytypeId']">
                          <option value="0">Select</option>
                          <option *ngFor="let policytype of policyTypes" value={{policytype.id}}>
                            {{policytype.name}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-3 form-block-cell">
                      <label class="form-control-label form-block-label">Risk Profile</label>
                      <div class="form-group form-block-input">
                        <select [formControl]="updateTaskForm.controls['RisktypeId']" class="form-control select">
                          <option value="0">Select</option>
                          <option *ngFor="let riskType of riskTypes" value={{riskType.id}}>
                            {{riskType.name}}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-3 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Date Option
                        <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                      </label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <select [formControl]="updateTaskForm.controls['DateOption']" class="form-control select">
                          <option value="">Select</option>
                          <option *ngFor="let dateOption of dateOptions" value={{dateOption.id}}>
                            {{dateOption.name}}
                          </option>
                        </select>
                        <!-- <div
                          *ngIf="updateTaskForm.controls['DateOption'].hasError('required') && (updateTaskForm.controls['DateOption'].dirty || updateTaskForm.controls['DateOption'].pristine)"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please Select Date option.
                        </div> -->
                      </div>
                    </div>
                    <div class="col-md-3 form-block-cell">
                      <label class="form-control-label form-block-label">Meeting Type</label>
                      <select [formControl]="updateTaskForm.controls['MeetingtypeId']" class="form-control select">
                        <option value="">None</option>
                        <option *ngFor="let meetingType of meetingTypes" value={{meetingType._id}}>
                          {{meetingType.MeetingType}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="form-block-row">
                  <div class="row">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Task Name
                        <span _ngcontent-c2="" style="color: red;">*</span>
                      </label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <input id="taskName" [formControl]="updateTaskForm.controls['TaskName']" class="form-control">
                        <div
                          *ngIf="(updateTaskForm.controls['TaskName'].hasError('required')  || updateTaskForm.controls['TaskName'].hasError('whitespace')) && (updateTaskForm.controls['TaskName'].dirty || updateTaskForm.controls['TaskName'].pristine)"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          The task name is required.
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Tag
                        <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                      </label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <div class="input-group">
                          <select [formControl]="updateTaskForm.controls['GroupId']" class="form-control select">
                            <option value="">Select</option>
                            <option *ngFor="let group of groupTypes" value={{group._id}}>
                              {{group.GroupName}}
                            </option>
                          </select>
                          <div class="input-group-append" style="margin-left: 8px;">
                            <button type="button" class="btn btn-primary" data-toggle="modal"
                              data-target="#groupDialog"
                              [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
                              <i class="fa fa-plus"></i>Add
                            </button>
                          </div>
                        </div>
                        <!-- <div
                          *ngIf="updateTaskForm.controls['GroupId'].hasError('required') && (updateTaskForm.controls['GroupId'].dirty || updateTaskForm.controls['GroupId'].pristine)"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Tag is required.
                        </div> -->
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Task Description
                        <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                      </label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <textarea [formControl]="updateTaskForm.controls['TaskDescription']" class="form-control"
                          rows="3"></textarea>
                        <!-- <div
                          *ngIf="(updateTaskForm.controls['TaskDescription'].hasError('required') || updateTaskForm.controls['TaskDescription'].hasError('whitespace')) && (updateTaskForm.controls['TaskDescription'].dirty || updateTaskForm.controls['TaskDescription'].pristine)"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Task description is required.
                        </div> -->
                      </div>
                    </div>

                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Email Contents</label>
                      <div class="form-group form-block-input">
                        <textarea [formControl]="updateTaskForm.controls['EmailContents']" class="form-control"
                          rows="3">
                        </textarea>
                      </div>
                    </div>
                  </div>
                </div>

                

                <div class="form-block-row">
                  <div class="row">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Assigned To</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="assignedusers" [multiple]="true" bindLabel="label" bindValue="value"
                          placeholder="Select User" [formControl]="updateTaskForm.controls['AssignedTo']"
                          (change)="onSelectMemberDisableFromOther(true)" class="form-control m-b-10 p-8"
                          style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>

                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Colleague</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="collegues" [multiple]="true" bindLabel="label" bindValue="value"
                          placeholder="Select collegue" [formControl]="updateTaskForm.controls['Collegues']"
                          (change)="onSelectMemberDisableFromOther()" class="form-control m-b-10 p-8"
                          style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Due Date</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <app-datepicker-material [formControl]="updateTaskForm.controls['CompletionDate']"
                         [(ngModel)]="CompletionDateModel" [placeholder]="'dd-mm-yyyy'" [disabled]="false">
                        </app-datepicker-material>
                        <div
                          *ngIf="updateTaskForm.controls['CompletionDays'].hasError('max') && (updateTaskForm.controls['CompletionDays'].dirty || updateTaskForm.controls['CompletionDays'].pristine)"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please enter a maximum 9999 days.
                        </div>
                        <div
                          *ngIf="updateTaskForm.controls['CompletionDays'].hasError('min') && (updateTaskForm.controls['CompletionDays'].dirty || updateTaskForm.controls['CompletionDays'].pristine)"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please enter a minimum -9999 days.
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Reminder Start Date</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <app-datepicker-material [formControl]="updateTaskForm.controls['ReminderDate']"
                          [placeholder]="'dd-mm-yyyy'" [disabled]="false" [minDate]="todaysDate" (click)="$event.stopPropagation()">
                        </app-datepicker-material>
                        <div
                          *ngIf="updateTaskForm.controls['ReminderDate'].hasError('reminderBeforeBase') && updateTaskForm.controls['ReminderDate'].touched"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Reminder start date cannot be earlier than the trigger start date or fixed date.
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Reminder Frequency (days)</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <input [formControl]="updateTaskForm.controls['ReminderFrequency']" class="form-control"
                          [OnlyNumber]=true (input)="checkRemindersValidation()">
                        <div
                          *ngIf="updateTaskForm.controls['ReminderFrequency'].hasError('max') && (updateTaskForm.controls['ReminderFrequency'].dirty || updateTaskForm.controls['ReminderFrequency'].pristine)"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please enter a maximum 30 days.
                        </div>
                        <div
                          *ngIf="updateTaskForm.controls['ReminderFrequency'].hasError('min') && updateTaskForm.controls['ReminderFrequency'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Reminder Frequency (days) cannot be negative.
                        </div>
                        <div id="ErrorreminderFrequency" *ngIf="reminderFrequencyError.isError"
                          style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          {{ reminderFrequencyError.errorMessage }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-block-row">
                  <div class="row">
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Responsible User</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="responsibleUsers" [multiple]="true" bindLabel="label"
                          bindValue="value" placeholder="Select"
                          [formControl]="updateTaskForm.controls['ResponsibleUser']"
                          (change)="onSelectMemberDisableFromOther()" class="form-control m-b-10 p-8"
                          style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>

                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Responsible User 1st Escalation</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="escalation1ofResponsibleUsers" [multiple]="true" bindLabel="label"
                          bindValue="value" placeholder="Select"
                          [formControl]="updateTaskForm.controls['Escalation1ofResponsibleUser']"
                          (change)="onSelectMemberDisableFromOther()"
                          class="form-control m-b-10 p-8" style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>

                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Responsible User 2nd Escalation</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="escalation2ofResponsibleUsers" [multiple]="true" bindLabel="label"
                          bindValue="value" placeholder="Select"
                          [formControl]="updateTaskForm.controls['Escalation2ofResponsibleUser']"
                          (change)="onSelectMemberDisableFromOther()"
                          class="form-control m-b-10 p-8" style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-block-row escalation-block">
                  <div class="escalation-header" (click)="isEscalationExpanded = !isEscalationExpanded" style="cursor: pointer; padding: 10px 20px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e9ecef;">
                    <h5 style="margin: 0; font-weight: 500; color: #333;">Escalation</h5>
                    <i class="fa" [ngClass]="{'fa-chevron-down': !isEscalationExpanded, 'fa-chevron-up': isEscalationExpanded}" style="color: #666;"></i>
                  </div>
                  <div *ngIf="isEscalationExpanded" style="padding: 15px 20px;">
                    <div class="row">
                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">1st Escalation</label>
                        <div class="form-group form-block-input">
                          <ng-select [items]="escalation1Users" [multiple]="true" bindLabel="label"
                            bindValue="value" placeholder="Select"
                            [formControl]="updateTaskForm.controls['Escalation1ofAssignedTo']"
                            (change)="onSelectMemberDisableFromOther()" class="form-control m-b-10 p-8"
                            style="padding: 0px; text-align:left;">
                          </ng-select>
                        </div>
                      </div>

                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">1st Escalation Start</label>
                        <div class="form-group form-block-input" style="position: relative;">
                          <input [formControl]="updateTaskForm.controls['EscalationDays']" class="form-control"
                            [OnlyNumber]=true (input)="checkRemindersValidation()">
                          <div
                            *ngIf="updateTaskForm.controls['EscalationDays'].hasError('max') && (updateTaskForm.controls['EscalationDays'].dirty || updateTaskForm.controls['EscalationDays'].pristine)"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            Please enter a maximum 30 days.
                          </div>
                          <div
                            *ngIf="updateTaskForm.controls['EscalationDays'].hasError('min') && updateTaskForm.controls['EscalationDays'].dirty"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            1st Escalation Start cannot be negative.
                          </div>
                          <div id="ErrorfirstEscalationStart" *ngIf="firstEscalationStartError.isError"
                            style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            {{ firstEscalationStartError.errorMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">1st Escalation reminder frequency</label>
                        <div class="form-group form-block-input" style="position: relative;">
                          <input [formControl]="updateTaskForm.controls['ReminderFrequencyLevel1']"
                            class="form-control" [OnlyNumber]=true (input)="checkRemindersValidation()">
                          <div
                            *ngIf="updateTaskForm.controls['ReminderFrequencyLevel1'].hasError('max') && (updateTaskForm.controls['ReminderFrequencyLevel1'].dirty || updateTaskForm.controls['ReminderFrequencyLevel1'].pristine)"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            Please enter a maximum 30 days.
                          </div>
                          <div
                            *ngIf="updateTaskForm.controls['ReminderFrequencyLevel1'].hasError('min') && updateTaskForm.controls['ReminderFrequencyLevel1'].dirty"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            1st Escalation reminder frequency cannot be negative.
                          </div>
                          <div id="ErrorfirstEscalationreminderFrequency"
                            *ngIf="firstEscalationreminderFrequencyError.isError"
                            style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            {{ firstEscalationreminderFrequencyError.errorMessage }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row" style="margin-top: 15px;">
                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">2nd Escalation</label>
                        <div class="form-group form-block-input">
                          <ng-select [items]="escalation2Users" [multiple]="true" bindLabel="label"
                            bindValue="value" placeholder="Select"
                            [formControl]="updateTaskForm.controls['Escalation2ofAssignedTo']"
                            (change)="onSelectMemberDisableFromOther()" class="form-control m-b-10 p-8"
                            style="padding: 0px; text-align:left;">
                          </ng-select>
                        </div>
                      </div>

                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">2nd Escalation Start</label>
                        <div class="form-group form-block-input" style="position: relative;">
                          <input [formControl]="updateTaskForm.controls['Level2EscalationDays']"
                            class="form-control" [OnlyNumber]=true (input)="checkRemindersValidation()">
                          <div
                            *ngIf="updateTaskForm.controls['Level2EscalationDays'].hasError('max') && updateTaskForm.controls['Level2EscalationDays'].touched && updateTaskForm.controls['Level2EscalationDays'].pristine"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            Please enter a maximum 30 days.
                          </div>
                          <div
                            *ngIf="updateTaskForm.controls['Level2EscalationDays'].hasError('min') && updateTaskForm.controls['Level2EscalationDays'].dirty"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            2nd Escalation Start cannot be negative.
                          </div>
                          <div id="ErrorsecondEscalationStart" *ngIf="secondEscalationStartError.isError"
                            style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            {{ secondEscalationStartError.errorMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">2nd Escalation reminder frequency</label>
                        <div class="form-group form-block-input" style="position: relative;">
                          <input [formControl]="updateTaskForm.controls['ReminderFrequencyLevel2']"
                            class="form-control" [OnlyNumber]=true (input)="checkRemindersValidation()">
                          <div
                            *ngIf="updateTaskForm.controls['ReminderFrequencyLevel2'].hasError('max') && (updateTaskForm.controls['ReminderFrequencyLevel2'].dirty || updateTaskForm.controls['ReminderFrequencyLevel2'].pristine)"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            Please enter a maximum 30 days.
                          </div>
                          <div
                            *ngIf="updateTaskForm.controls['ReminderFrequencyLevel2'].hasError('min') && updateTaskForm.controls['ReminderFrequencyLevel2'].dirty"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            2nd Escalation reminder frequency cannot be negative.
                          </div>
                          <div id="ErrorsecondEscalationreminderFrequency"
                            *ngIf="secondEscalationreminderFrequencyError.isError"
                            style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            {{ secondEscalationreminderFrequencyError.errorMessage }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-block-row">
                  
                  <div class="row">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">System Defined Consequences</label>
                      <div class="form-group form-block-input">
                        <textarea disabled [formControl]="updateTaskForm.controls['PreConsequences']" class="form-control"
                          rows="3">
                        </textarea>
                      </div>
                    </div>

                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">User Defined Consequences</label>
                      <div class="form-group form-block-input">
                        <textarea [formControl]="updateTaskForm.controls['UserConsequences']" class="form-control" rows="3">
                        </textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label">Upload File</label>
                      <div class="form-group form-block-input">
                        <div *ngIf="imageEdit">
                          <input type="text" [formControl]="updateTaskForm.controls['DocumentFile']"
                              class='form-control' readonly='true'>
                        </div>
                        <div *ngIf="imageAdd">
                          <input type="hidden" [formControl]="updateTaskForm.controls['DocumentFile']">
                          <input type="file" class='form-control' (change)="onFileChanged($event)"
                              accept=".xlsx, .xls, .doc, .docx, .pdf" />
                        </div>
                        <div *ngIf="imageAddRev">
                          <button type="button" class="btn-sm btn btn-default" (click)="revert()">
                              <span class="fa fa-refresh"></span>
                          </button>
                        </div>
                        <div *ngIf="imageEdit">
                          <button *ngIf="imageEdit && selectedFileName" type="button"
                              class="btn-sm btn btn-warning" (click)="downloadDoc()">
                              <span class="fa fa-download"></span>
                          </button>
                          <button type="button" class="btn-sm btn btn-primary" (click)="addNewDoc()">
                              <i class="fa fa-plus"></i>Add New files
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Emails</label>
                      <div class="form-group form-block-input">
                        <div class="md-radio md-radio-inline">
                          <input id="sendMailYes" type="radio" [formControl]="updateTaskForm.controls['Email']"
                            style="position:absolute" name="Email" [value]="true" class="form-check-input">
                          <label for="sendMailYes">ON</label>
                        </div>
                        <div class="md-radio md-radio-inline">
                          <input id="sendMailNo" type="radio" [formControl]="updateTaskForm.controls['Email']"
                            style="position:absolute" name="Email" [value]="false" class="form-check-input">
                          <label for="sendMailNo">OFF</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2"
                    *ngIf="environmentSettings.TaskMakerChecker && TaskReview">
                    <label class="form-control-label" for="l0">Approve Status
                      <span _ngcontent-c2="" style="color: red;">*</span>
                    </label>
                  </div>
                  <div class="col-md-4"
                    *ngIf="environmentSettings.TaskMakerChecker &&  TaskReview">
                    <div class="form-group">
                      <div class="md-radio md-radio-inline">
                        <input id="approveYes" type="radio" style="position:absolute" name="approve"
                          [formControl]="updateTaskForm.controls['isApproved']" value='true' class="form-check-input">
                        <label for="approveYes">Approve</label>
                      </div>
                      <div class="md-radio md-radio-inline"
                        *ngIf="environmentSettings.TaskMakerChecker ">
                        <input id="approveNo" type="radio" style="position:absolute" name="approve"
                          [formControl]="updateTaskForm.controls['isApproved']" value='false' class="form-check-input">
                        <label for="approveNo">Reject</label>
                      </div>
                    </div>
                  </div>


                  <div class="col-md-2"
                    *ngIf="environmentSettings.TaskMakerChecker && updateTaskForm.controls['isApproved'].value == 'false'">
                    Comment:
                  </div>
                  <div class="col-md-4"
                    *ngIf="environmentSettings.TaskMakerChecker && updateTaskForm.controls['isApproved'].value == 'false'">
                    <div class="form-group">
                      <textarea class="form-control"
                        [formControl]="updateTaskForm.controls['taskRejectComment']"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button id="btnupdateTask" type="button" class="btn btn-sm btn-primary"
                  [disabled]="!updateTaskForm.valid  || disabledOnclick"
                  [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}"
                  (click)="updateTask(true, 'update')"><i class="fa fa-save"></i>&nbsp;Update</button>

                <div *ngIf="!isActivatedTaskHidden">
                  <button id="btnshowtaskparticulars" *ngIf="environmentSettings.TaskMakerChecker && TaskReview" (click)="showTaskParticulars(true, 'updateAndActivate')"
                    type="button" data-toggle="modal" class="btn btn-sm btn-primary"
                    [disabled]="!updateTaskForm.valid  || disabledOnclick"><i class="fa fa-save"></i>&nbsp;Update &
                    Activate</button>
                    <button id="btnshowtaskparticulars" *ngIf="!environmentSettings.TaskMakerChecker" (click)="showTaskParticulars(true, 'updateAndActivate')"
                    type="button" data-toggle="modal" class="btn btn-sm btn-primary"
                    [disabled]="!updateTaskForm.valid  || disabledOnclick"><i class="fa fa-save"></i>&nbsp;Update &
                    Activate</button>
                </div>
                <!-- <button type="button" class="btn btn-sm" data-dismiss="modal">Clear</button> -->
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>


  <div class="modal  modal-size-medium" id="taskParticularsDialog" tabindex="-1" role="dialog" aria-labelledby=""
    aria-hidden="true">
    <div class="modal-dialog">
      <form [formGroup]="updateTaskForm" class="well">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel"><i class="fa fa-plus"></i>Task Particulars</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button"
              (click)="removeTaskParticularsvalidation()">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-3">
                <label class="form-control-label" for="l0">Task Particulars
                  <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                </label>
              </div>
              <div class="col-md-9">
                <div class="form-group">

                  <input [formControl]="updateTaskForm.controls['TaskParticulars']" class="form-control"
                    [(ngModel)]="taskParticularsmodel">
                  <!-- <div
                    *ngIf="updateTaskForm.controls['TaskParticulars'].hasError('required') && (updateTaskForm.controls['TaskParticulars'].dirty || updateTaskForm.controls['TaskParticulars'].pristine)"
                    class="form-control-error-custom">
                    Task Particulars Name is required.
                  </div> -->
                  <!-- <div *ngIf="(taskParticularsmodel=== undefined)" class="form-control-error-custom">
                      Task Particulars Name is required.
                   </div>  -->
                  <!-- <div *ngIf="updateTaskForm.controls['TaskParticulars'].hasError('pattern') && updateTaskForm.controls['TaskParticulars'].dirty" class="form-control-error-custom">
                    Please enter  valid Task Particulars Name.
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">

            <button id="btnupdateandActivateTask" *ngIf="environmentSettings.TaskMakerChecker && TaskReview" type="button" class="btn btn-sm btn-primary"
              [disabled]='!updateTaskForm.valid || disabledOnclick || (taskParticularsmodel=== undefined)'
              (click)="updateTaskandActivate()"><i class="fa fa-save"></i>&nbsp;Update and Activate</button>

            <button id="btnupdateandActivateTask" type="button" class="btn btn-sm btn-primary" *ngIf="!environmentSettings.TaskMakerChecker"
              [disabled]='!updateTaskForm.valid || disabledOnclick || (taskParticularsmodel=== undefined)'
              (click)="updateTaskandActivate()"><i class="fa fa-save"></i>&nbsp;Update and Activate</button>

            <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="removeTaskParticularsvalidation()"><i
                class="fa fa-times"></i>&nbsp;Close</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
<app-add-group (groupCreated)='getGroupId($event)'></app-add-group>
<app-alert></app-alert>

<div class="modal " id="confirmationBoxForUpdateTriggerEndDate" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-question-circle-o mr-2"></i>Confirm
        </h5>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            After End Date further activated task will be cancelled if present. Do you want to update the End Date?
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-danger" (click)="updateTask(false, 'update')">
          <i class="fa fa-check"></i>&nbsp;Yes</button>
        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
          <i class="fa fa-times"></i>&nbsp;No</button>
      </div>
    </div>
  </div>
</div>

<div class="modal " id="confirmationBoxForUpdateAndActivateTriggerEndDate" tabindex="-1" role="dialog"
  data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-question-circle-o mr-2"></i>Confirm
        </h5>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            After End Date further activated task will be cancelled if present. Do you want to update the End Date?
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-danger" (click)="showTaskParticulars(false, 'updateAndActivate')">
          <i class="fa fa-check"></i>&nbsp;Yes</button>

        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
          <i class="fa fa-times"></i>&nbsp;No</button>
      </div>
    </div>
  </div>
</div>